import React from 'react';
import { useFormikContext, useField, Field, ErrorMessage } from 'formik';
import TimePickerField from './TimePickerField';
import moment from 'moment';



function calculateTotalHours(dayName, fields) {
    const In = moment(fields[dayName + "In"], "hh:mm");
    const Out = moment(fields[dayName + "Out"], "hh:mm");

    const LunchIn = moment(fields[dayName + "LunchIn"], "hh:mm");
    const LunchOut = moment(fields[dayName + "LunchOut"], "hh:mm");

    const dayPeriod = Out.diff(In, 'hours', true);
    const lunchPeriod = LunchOut.diff(LunchIn, 'hours', true);

    if (lunchPeriod) {
        return dayPeriod - lunchPeriod;
    }
    else {
        return dayPeriod
    }
    
}

/* Gets passed a 'day' prop like so:
 * {
 *    date: 
 *    dayName: (e.g. Saturday, Sunday...)
 *    in: 
 *    out:
 *    lunchIn: 
 *    lunchOut:
 * }
 */
export const TimestampField = ({ ...props }) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);

    const totalHours = calculateTotalHours(props.day.dayName, field.value) || 0;

    const holidays = props.holidays;

    return (
        <React.Fragment>
        <tr className={holidays.length > 0 ? "isHoliday" : ""}>
            <th className="text-center align-middle" scope="row">
                <p style={{ marginBottom: "0" }}>{props.day.dayName}</p>
                <span className="sub">{props.day.date.format("l")}</span>
            </th>

            <td className="pad-left">
                <TimePickerField name={props.day.dayName + "In"} label={props.day.dayName + " Day Start"} disabled={props.disabled} />
            </td>
            <td className="pad-left">
                <TimePickerField name={props.day.dayName + "Out"} label={props.day.dayName + " Day End"} disabled={props.disabled} />
            </td>
            <td className="pad-left">
                <TimePickerField name={props.day.dayName + "LunchIn"} label={props.day.dayName + " Lunch Start"} disabled={props.disabled} />
            </td>
            <td className="pad-left">
                <TimePickerField name={props.day.dayName + "LunchOut"} label={props.day.dayName + "Lunch End"} disabled={props.disabled} />
            </td>
            <td className="text-center align-middle">
                {totalHours.toFixed(2)}
            </td>
        </tr>
        {holidays.length > 0 && (
            <tr className="holidayInfoRow">
                <td colSpan="6"><b>Note: </b>
                    {holidays[0].note  ? holidays[0].note : ` ${holidays[0].holidayName} takes place on this day. Please ensure any hours you worked are logged accurately.`}
                </td>
            </tr>
        )}
        </React.Fragment>
     )
}

export default TimestampField;

